// extracted by mini-css-extract-plugin
module.exports = {"root":"Tab_root__1xpVI","small":"Tab_small__1kEHW","selected":"Tab_selected__1ODdY"};